

export default {
  SET_CLUB_INFO (state, payload) {
    state.clubInfo = payload
    localStorage.setItem('clubInfo', JSON.stringify(payload))
  }
}
